import { connect } from 'react-redux';

import { AUTH_SEND, AUTH_SEND_LINK } from 'apps/auth/constants/UrlConstants';

import { SelectCountryScreenPureComponent } from '../common/search/SelectCountryScreen';

const mapStateToProps = (state, ownProps) => {
    return {
        countries: ownProps.countries,
        userCountry: state.extra.userCountry,
        countriesHeader: state.messages.pageMessages.countriesHeader,
        searchPlaceholder: state.messages.pageMessages.searchPlaceholder,
        fullScreenSearchPlaceholder: state.messages.pageMessages.searchByCountryPlaceholder,
        gotIt: state.messages.pageMessages.gotIt,
        notificationText: state.messages.pageMessages.notificationText,
        searchNoResult: state.messages.pageMessages.searchNoResult,
        sendUrIPrefix: AUTH_SEND_LINK,
        fullViewSearchBackUri: AUTH_SEND,
        suppressRecentCountries: true,
        onCountryItemClick: ownProps.onCountryItemClick,
        ccyField: ownProps.ccyField,
        title: ownProps.title,
        hasCustomSorting: ownProps.hasCustomSorting,
    };
};

const SelectFromCountryCurrencies = connect(mapStateToProps)(SelectCountryScreenPureComponent);

export default SelectFromCountryCurrencies;
